export function buildSharedPayloadFromLoginResponse(payload = {}) {
  const brokerType = payload?.broker_type || "";
  const user = payload?.user || {};
  const brokerData = payload?.broker || {};

  return {
    ...payload,
    broker_type: brokerType,
    ID: String(user?.id ?? ""),
    First_Name: user?.first_name || "",
    Last_Name: user?.last_name || "",
    Email_ID: user?.email || "",
    accessToken: brokerData?.jwt_token || brokerData?.access_token || "",
    refresh_token: brokerData?.refresh_token || "",
    feed_token: brokerData?.feed_token || "",
    ClientCode: brokerData?.client_code || "",
    api_key: brokerData?.api_key || "",
    grow_user_id: brokerData?.grow_user_id || "",
    vendor_user_id: brokerData?.vendor_user_id || "",
    ucc: brokerData?.ucc || "",
    active_segments: brokerData?.active_segments || [],
  };
}

export function persistAuthSessionFromPayload(payload = {}) {
  const sharedPayload = buildSharedPayloadFromLoginResponse(payload);
  const user = payload?.user || {};
  const brokerType = payload?.broker_type || "";
  const brokerData = payload?.broker || {};

  localStorage.setItem("sharedData", JSON.stringify(sharedPayload));
  localStorage.setItem("margin2", JSON.stringify(sharedPayload?.broker?.margin));
  localStorage.setItem("margin", sharedPayload?.broker?.margin);
  localStorage.setItem("broker_type", String(brokerType));
  localStorage.setItem("account_name", brokerData?.account_name || "");
  localStorage.setItem("id", String(user?.id ?? ""));
  localStorage.setItem("first_name", user?.first_name || "");
  localStorage.setItem("last_name", user?.last_name || "");
  localStorage.setItem("email", user?.email || "");
  localStorage.removeItem("visibleColumns");

  return sharedPayload;
}
